import axios, { AxiosError } from 'axios'
import { WISESHEETS_API_URL } from '../../constants'
import { useAuthStore } from '../state/store'
import { ApiErrorCode, parseApiError, logApiError } from './api-errors'

// Create the main HTTP client
export const httpClient = axios.create({
    baseURL: WISESHEETS_API_URL,
    timeout: 60000,
})

// Request interceptor - add auth token
httpClient.interceptors.request.use(
    async (config) => {
        const token = useAuthStore.getState().token
        if (config.headers !== undefined && token) {
            config.headers.Authorization = token
        }
        return config
    },
    (error) => Promise.reject(error)
)

// Response interceptor - handle errors consistently
httpClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        const apiError = parseApiError(error, {
            url: error.config?.url,
            method: error.config?.method,
        })

        // Handle token expiration - clear auth state and let app redirect to login
        if (
            apiError.code === ApiErrorCode.UNAUTHORIZED ||
            apiError.code === ApiErrorCode.TOKEN_EXPIRED
        ) {
            const logout = useAuthStore.getState().logout
            logout()
            // Clear all auth-related localStorage keys including Zustand persist key
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('fmpApiKey')
            window.localStorage.removeItem('auth')
        }

        logApiError(apiError)
        return Promise.reject(apiError)
    }
)

// Re-export ApiError for typing in catch blocks
export { ApiError } from './api-errors'
